import React, { useEffect, useState } from "react";
import { APP_URL, CAP_IG_AUTH_REDIRECT_ROUTE, IG_AUTH_REDIRECT_ROUTE, IG_HELPDESK_URL, INIT_IG_AUTH_ROUTE, NEW_IG_AUTH_METHOD, WEB_APP_URL } from "../../constants/constants";
import MobileView from "../../layouts/MobileView/MobileView";
import { useNavigate } from "react-router-dom";
import { linkInstagramAccount, storeAccessToken } from "../../services/api/influencer";
import { AppDispatch, getIntendedPath, RootState, store } from "../../redux-stores/store";
import { useDispatch } from "react-redux";
import { fetchInfluencer } from "../../redux-stores/slices/influencerSlice";
import { login } from "../../redux-stores/slices/authSlice";
import { encryptData } from "../../utils/cryptography";
import { debug } from "../../services/api/auth";
import AuthLayout from "../../layouts/AuthLayout";
import ConnectIGComponent from "../../components/igConnect/ConnectIGComponent";
import { useSelector } from "react-redux";
import { Browser } from "@capacitor/browser";
import { isNativePlatform } from "../../utils/platformUtil";

const REDIRECT_URI = (isNativePlatform() ? WEB_APP_URL : APP_URL) + (isNativePlatform() ? CAP_IG_AUTH_REDIRECT_ROUTE : IG_AUTH_REDIRECT_ROUTE);

export enum ConnectIGStatus {
    DEFAULT = 'Please wait...',
    URL_FETCHED = 'Connect Your Instagram',
    REDIRECTING = 'Redirecting to Instagram...',
    CONNECTING = 'Connecting...',
    CONNECTED = 'Connected',
    FETCHING = 'Fetching...',
    ERROR = 'Failed',
    RETURN='Return To App'
}

const ConnectIGRedir: React.FC = () => {
    const [connected, setConnected] = useState<boolean>(false);
    const [connecting, setConnecting] = useState<boolean>(false);
    const { isAuthenticated } = useSelector((state: RootState) => state.auth);

    const [error, setError] = useState<any>(null);
    const [status, setStatus] = useState<ConnectIGStatus>(ConnectIGStatus.DEFAULT);

    const dispatch: AppDispatch = useDispatch();

    const navigate = useNavigate();

    useEffect(() => {


        const handleIGRedirection = async (code: string) => {
            // This function runs when instagram redirects back after auth with a authorization token
            const connectionStatus: {status: ConnectIGStatus, error: string|null} = {status, error};
            try {
                setConnecting(true);
                if(isAuthenticated){
                    setStatus(ConnectIGStatus.FETCHING);
                    let igUserId = '';
                    try {
                        const response = await storeAccessToken(code, REDIRECT_URI);
                        if (!response.status) throw new Error("Failed to connect Instagram");
                        if (!response.id) throw new Error("Account not found.")
                        igUserId = response.id;

                    } catch (error:any) {
                        let errorMessage = "Something went wrong, Please try again.";
                        if(error?.response?.data?.error === 'account_mismatch'){
                            const newUsername = error.response.data.new_username ?? ''
                            const currentUsername = error.response.data.current_username ?? ''
                            errorMessage = `You are trying to connect a new Instagram account <b>@${newUsername}</b>. Kindly connect the same Professional Instagram account that you already have linked earlier <b>@${currentUsername}</b>`;
                        }
                        throw new Error(errorMessage)
                    }
                    if (!igUserId) throw new Error("Account not found.")

                    setStatus(ConnectIGStatus.CONNECTING);
                    await linkInstagramAccount(igUserId);
                    await dispatch(fetchInfluencer(store.getState().auth.token!));
                    await dispatch(login(store.getState().auth.token!));

                    if(NEW_IG_AUTH_METHOD && !isNativePlatform()){
                        connectionStatus.status = ConnectIGStatus.CONNECTED;
                        connectionStatus.error = null;
                    }else{
                        navigate(getIntendedPath());
                        setStatus(ConnectIGStatus.CONNECTED);
                        setConnected(true);
                    }
                }
            } catch (error: any) {
                if(NEW_IG_AUTH_METHOD && !isNativePlatform()){
                    connectionStatus.status = ConnectIGStatus.ERROR;
                    connectionStatus.error = error.message;
                }else{
                    setError(error.message)
                    setStatus(ConnectIGStatus.ERROR);
                }
            } finally {
                if(NEW_IG_AUTH_METHOD && !isNativePlatform()){
                    localStorage.setItem('ig_connection_status', encryptData(connectionStatus));
                    window.close();
                }else{
                    setConnecting(false);
                    setConnected(false);
                }
            }
        }

        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');

        if (code) {
            handleIGRedirection(code);
        } else {
            setError("Authorization code not found");
            setStatus(ConnectIGStatus.ERROR);
        }

    }, [navigate, dispatch, isAuthenticated]);

    useEffect(() => {
        if(isNativePlatform()){
            Browser.close();
        }
    }, [])

    useEffect(() => {
        // debug()
        if(!isAuthenticated) return;
        debug({status, error, path: window.location.pathname, origin: window.location.origin}).catch((err) => console.log(err));
    }, [error, status, isAuthenticated]);

    const viewHelpClickHandler = () => {
        debug({status: 'View Help', error, path: window.location.pathname, origin: window.location.origin});
    }
    

    return (
        <MobileView>
            <AuthLayout>
                <ConnectIGComponent 
                    error={error}
                    status={status}
                    connect={() => navigate(INIT_IG_AUTH_ROUTE)}
                />
            </AuthLayout>
        </MobileView>
    );
};

export default ConnectIGRedir;